webpackJsonp([12],{

/***/ 59:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;!(__WEBPACK_AMD_DEFINE_ARRAY__ = [
		__webpack_require__(3),
		__webpack_require__(5),
		__webpack_require__(12)
	], __WEBPACK_AMD_DEFINE_RESULT__ = function (utils, pubsub, nanoajax) {
		'use strict';
	
		/**
		 * searchTracking
		 * Some helpers for the search-page
		 * @version 1.0.0
		 * @exports searchTracking
		 */
		var searchTracking = {
			/**
			 * The initialization function for this module.
			 * @public
			 */
			init: function () {
				this._addEventListener();
			},
	
	
	
			_addEventListener: function () {
				utils.addEventListener(document, 'click', function (event) {
					var currentTag = event.target;
	
					while (currentTag !== null && currentTag.getAttribute && currentTag.getAttribute('data-hitid') === null) {
						currentTag = currentTag.parentNode;
					}
	
					if (currentTag !== null && currentTag.getAttribute && currentTag.getAttribute('data-hitid') !== null) {
						var hitId = currentTag.getAttribute('data-hitid'),
							trackId = currentTag.getAttribute('data-trackid'),
							query = currentTag.getAttribute('data-query'),
							url = '/api/clicktracking/track?query=' + query + '&hitId=' + hitId + '&trackId=' + trackId;
	
						nanoajax.ajax({
							method: 'GET',
							headers: {
								'X-Requested-With': 'XMLHttpRequest'
							},
							url: url
						});
					}
				});
			}
		};
	
	
		return searchTracking;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));


/***/ })

});


// WEBPACK FOOTER //
// partial.12.js